import userService from '../../services/userService'
import router from '../../router'

const role = 'client'

const state = {
  csrfToken: null,
  loggedUser: null,
}

const getters = {
  getLoggedUser(state) {
    return state.loggedUser
  },
  getToken(state) {
    return state.csrfToken
  },
}

const mutations = {
  login(state, payload) {
    state.csrfToken = payload.csrfToken
    state.loggedUser = payload.user
  },
  logout(state) {
    state.csrfToken = null
    state.loggedUser = null
  },
}

const actions = {
  loadUsersCash({commit}) {
    var auth = JSON.parse(sessionStorage.getItem('auth'))
    if (auth && auth.user.role === role) {
      commit('login', auth)
    }
  },
  login({commit}, credentials) {
    return userService.login(credentials.email, credentials.password, role)
      .then(res => {
        sessionStorage.setItem('auth', JSON.stringify(res))
        commit('login', res)
      })
  },
  logout({commit}, credentials) {
    commit('logout')
    router.push('/login')
    sessionStorage.clear()
    return userService.logout()
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/-client-app/store/modules/usersStore.js